import { render } from "./MaCarte.vue?vue&type=template&id=8bd209ee&scoped=true"
import script from "./MaCarte.vue?vue&type=script&lang=js"
export * from "./MaCarte.vue?vue&type=script&lang=js"

import "./MaCarte.vue?vue&type=style&index=0&id=8bd209ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd209ee"]])

export default __exports__